import { alpha, styled, Theme } from '@mui/material';

export type PillTone = 'primary' | 'neutral' | 'success' | 'warning' | 'error';

const toneColor = (theme: Theme, tone: PillTone): string =>
  tone === 'neutral' ? theme.palette.text.secondary : theme.palette[tone].main;

export const Pill = styled('span', {
  shouldForwardProp: (prop) => prop !== 'tone' && prop !== 'dot',
})<{ tone: PillTone; dot?: boolean }>(({ theme, tone, dot }) => {
  const main = toneColor(theme, tone);
  return {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
    padding: theme.spacing(0.5, 1.25),
    borderRadius: '999px',
    fontSize: '0.7rem',
    fontWeight: 700,
    letterSpacing: '0.03em',
    lineHeight: 1,
    color: main,
    backgroundColor: alpha(main, 0.12),
    border: `1px solid ${alpha(main, 0.4)}`,
    whiteSpace: 'nowrap',
    ...(dot && {
      '&::before': {
        content: '""',
        flex: 'none',
        width: 6,
        height: 6,
        borderRadius: '50%',
        backgroundColor: 'currentColor',
      },
    }),
  };
});

export default Pill;
